import { Collection, RefSerializer } from "@tblabs/truffle";
import { RawJobOffer } from "./RawJobOffer";
import { JobOffer } from "./JobOffer";
import { JobOfferDescriptionEntry } from "./JobOfferDescriptionEntry";
import { JobOfferQuestionEntry } from "./JobOfferQuestionEntry";
import { Converter } from "@tblabs/storage";


export class JobOfferConverter extends Converter<RawJobOffer, JobOffer>
{
    public ConvertToRaw(job: JobOffer): RawJobOffer
    {
        const raw = RefSerializer.Flatenize(job) as unknown as RawJobOffer;

        return raw;
    }

    public ConvertFromRaw(raw: RawJobOffer): JobOffer
    {
        try
        {
            const job = new JobOffer(raw.Id);

            job.Title.value = this.GetString(raw.Title);
            job.IsRecruitmentOpen.value = this.GetBool(raw.IsRecruitmentOpen);
            job.Description = this.GetCollection<JobOfferDescriptionEntry>(raw.Description, x => new JobOfferDescriptionEntry(x.Label, x.Text));
            job.Form = this.GetCollection<JobOfferQuestionEntry>(raw.Form, x => new JobOfferQuestionEntry(x.Question, x.Answer));
            job.CreatedAt = this.GetDate(raw.CreatedAt);

            return job;
        }
        catch (error)
        {
            console.log(error);
            return new JobOffer(raw.Id);
        }
    }

    private GetCollection<T>(value: any, creator: (raw: any) => T): Collection<T>
    {
        const collection = value?.map(x => creator(x));

        return new Collection<T>(collection);
    }
}
